import { Stack as MuiStack, Box as MuiBox } from '@mui/material';

/**
 * Stack — flexbox container with spacing between children.
 * Box — generic layout element with MUI sx prop.
 *
 * Thin MUI wrappers.
 */
export const Stack = (props) => <MuiStack {...props} />;
export const Box = (props) => <MuiBox {...props} />;

export default Stack;
